import React from 'react'

export default function About(){
  return (
    <main>
      {/* Page Header Start */}
      <section className="container-fluid page-banner black-banner" style={{background: 'url(/img/Aboutlogo.jpeg) center', height: '580px', backgroundSize: 'cover', backgroundPositionY: '54%'}}>

      {/* <section className="page-banner py-5" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white'}}> */}
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 font-weight-bold mb-3">About Us</h1>
              {/* <p className="lead mb-0">Learn about our commitment to quality healthcare and pharmaceutical excellence</p> */}
            </div>
            {/* <div className="col-lg-4 text-lg-right">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb bg-transparent p-0 m-0">
                  <li className="breadcrumb-item"><a href="/" className="text-white">Home</a></li>
                  <li className="breadcrumb-item active text-white" aria-current="page">About Us</li>
                </ol>
              </nav>
            </div> */}
          </div>
        </div>
      </section>
      {/* Page Header End */}
      {/* Why Choose Us Section */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <h2 className="card-title section-title mb-4">Why Choose Us</h2>
                  <p className="card-text text-muted mb-4">From the very beginning LAKULISH is focused on providing supreme quality finished pharmaceutical products and service to its esteemed patrons. To make sure of the same, LAKULISH believes and follows to improve the product's Quality, Safety & Efficacy.</p>
                  <p className="card-text text-muted mb-4">"The systems and processes must be designed to be more resistant to error occurrence and more accommodating of error consequence" in identification and filtration of its suppliers based in India, USA, Europe and china, who over a period of time have become tangible assets of LAKULISH family.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm">
                <img className="card-img-top" src="/img/about_header.jpg" alt="Lakulish Pharmaceuticals Quality" style={{height: '300px', objectFit: 'cover'}} />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Mission, Vision & Values */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center">
                  <div className="mb-3">
                    <span className="display-4">🎯</span>
                  </div>
                  <h3 className="card-title text-primary mb-4">Mission</h3>
                  <ul className="text-left">
                    <li>To be a globally admired pharmaceutical company, providing excellent quality of products to our customers and people to keep world healthy.</li>
                    <li>To dedicate ourselves for humanity's quest for longer, healthier, happier lives through innovation in medicines.</li>
                    <li>To observe highest ethical standards & fair business practices; and maintain highest standards of integrity at all levels of business.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center">
                  <div className="mb-3">
                    <span className="display-4">🔭</span>
                  </div>
                  <h3 className="card-title text-primary mb-4">Vision</h3>
                  <ul className="text-left">
                    <li>To become a globally acclaimed pharmaceutical company through development and introduction of wide portfolio of Pharmaceutical product with integration of four main ethics "Research, Quality, Health & Life".</li>
                    <li>To uphold our social responsibilities of delivering highest standard healthcare services to all segments of society without compromising on our core values of integrity, good ethics and commitment.</li>
                    <li>To become the leading pharmaceutical player in the industry by assuring high quality standards and cost effective products at all times.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center">
                  <div className="mb-3">
                    <span className="display-4">💎</span>
                  </div>
                  <h3 className="card-title text-primary mb-4">Values</h3>
                  <ul className="text-left text-justify">
                    <li><strong>Innovation:</strong> Foster creativity and advance skills, technology, and processes.</li>
                    <li><strong>Integrity:</strong> Uphold honesty and moral principles.</li>
                    <li><strong>Service:</strong> Excel in products and services, exceeding expectations.</li>
                    <li><strong>Stewardship and Collaboration:</strong> Honor team commitments through cooperation and transparency.</li>
                    <li><strong>Performance Focus:</strong> Pursue ambitious goals and accelerate growth.</li>
                    <li><strong>Care for Society:</strong> Contribute to social and environmental well-being.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Commitments Section */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text-center mb-5">
                <h2 className="display-4 font-weight-bold text-primary mb-4" style={{color: '#5d4037'}}>Our Commitments</h2>
                <p className="lead text-muted">Dedicated to excellence in healthcare and pharmaceutical innovation</p>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <h3 className="card-title text-primary mb-4" style={{color: '#5d4037'}}>Our Commitments</h3>
                  <ul>
                    <li>To create innovative medicines changing Standard of Care. Standard of Care: Universally applied best treatment practice in today's medical science.</li>
                    <li>To take a global perspective, and respect regional values.</li>
                    <li>To foster intellectual curiosity and strategic insight.</li>
                    <li>To provide the highest quality medical information.</li>
                    <li>To provide a stable supply of top-quality pharmaceutical products.</li>
                    <li>To be an ethical, trusted, and respectful partner.</li>
                    <li>To be accountable for achieving our goals.</li>
                    <li>To demonstrate professionalism, respect for others and teamwork.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <h3 className="card-title text-primary mb-4" style={{color: '#5d4037'}}>LAKULISH Is</h3>
                  <ul>
                    <li>A research & development based strategic group of companies for pharmaceutical finished dosage forms for Oral Solid, Oral Liquid, Injectable, Ophthalmic, Rectal, Vaginal, Inhaled Dry Powder, Topical preparations, Nutraceuticals, Hygiene Products, Gloves and Medical Devices.</li>
                    <li>A one-stop destination for formulation development, Analytical method development, Regulatory documentation & contract manufacturing for pharmaceutical products.</li>
                    <li>Specialized to structure the deals to minimize the risk to our client, as we understand the dynamics of the markets.</li>
                    <li>To support in licensing the product with the help of our brilliant R&D partners throughout India, USA and Europe.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm" style={{backgroundColor: '#f5f5f0'}}>
                <div className="card-body">
                  <h3 className="card-title text-primary mb-4 text-center" style={{color: '#5d4037'}}>LAKULISH Supports With</h3>
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="list-unstyled">
                        <li className="mb-3"><i className="fas fa-chart-line text-primary mr-2"></i>Strategic Portfolio and Pipeline Selection</li>
                        <li className="mb-3"><i className="fas fa-microscope text-success mr-2"></i>Contract Research in Formulation Development & Analytical Research</li>
                        <li className="mb-3"><i className="fas fa-industry text-warning mr-2"></i>Contract Manufacturing of pharmaceutical products</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="list-unstyled">
                        <li className="mb-3"><i className="fas fa-file-contract text-info mr-2"></i>Regulatory, IPR & Legal Documentation</li>
                        <li className="mb-3"><i className="fas fa-chart-bar text-danger mr-2"></i>Product Sales and Marketing Analysis</li>
                        <li className="mb-0"><i className="fas fa-network-wired text-secondary mr-2"></i>Global Generic and Branded Networking</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
